import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SMOVaultService } from '../smovault.service';
import { MeuCertificadoDto } from '../smovault.dto';

@Component({
  selector: 'app-aviso-certificado',
  templateUrl: './aviso-certificado.component.html',
  styleUrls: ['./aviso-certificado.component.less']
})
export class AvisoCertificadoComponent implements OnInit, OnDestroy {
  certificadosVencidos: MeuCertificadoDto[] = [];
  certificadosVencendo: MeuCertificadoDto[] = [];
  private destroy$ = new Subject<void>();

  constructor(private vaultService: SMOVaultService) { }

  ngOnInit(): void {
    this.verificarCertificados();
    
    // Escutar atualizações de certificados
    this.vaultService.certificadoAtualizado$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.verificarCertificados();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private verificarCertificados(): void {
    const hoje = new Date();
    const em30Dias = new Date();
    em30Dias.setDate(hoje.getDate() + 30);

    this.vaultService.listarMeusCertificadosVencendoOuVencidos({
      dataInicial: hoje,
      dataFinal: em30Dias
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (certificados) => {
          this.certificadosVencidos = certificados.filter(c => 
            new Date(c.dataHoraValidadeFinal) < hoje
          );
          this.certificadosVencendo = certificados.filter(c => 
            new Date(c.dataHoraValidadeFinal) >= hoje
          );
        },
        error: () => {
          // Silenciosamente ignora erros para não impactar a UI
        }
      });
  }

  get diasParaVencer(): number | null {
    if (this.certificadosVencendo.length === 0) return null;
    
    const hoje = new Date().getTime();
    const menorData = Math.min(...this.certificadosVencendo.map(c => 
      new Date(c.dataHoraValidadeFinal).getTime()
    ));
    
    return Math.ceil((menorData - hoje) / (1000 * 60 * 60 * 24));
  }

  formatarData(data: Date): string {
    return new Date(data).toLocaleDateString('pt-BR');
  }
}
